import React from "react";
import blackBanner from "./image/black-banner.png";
import lineBg from "./image/line-bg.png";
import feature1 from "./image/features-1.png";
import feature2 from "./image/features-2.png";
import feature3 from "./image/features-3.png";
import safer2 from "./image/safer-world-2.png";
import shape2 from "./image/security-shape-2.png";
import certifiedLogos from "./image/certifiedLogos.webp";
function BannerSection() {
  return (
    <>
      <div className="new-main-banner-area-with-black-color">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="new-main-banner-black-content">
                <h1>Protect Your Business from Modern Cyber Threats</h1>
                <p>
                  Cyber attackers are always finding new ways to exploit vulnerabilities. That’s where we come in. Our mission is simple: be your digital shield.
                  We combine cutting-edge technology, smart defense strategies, and expert intelligence to keep your critical data safe. With us, you can focus on growing your business while we guard your information against unauthorized access and cyber attacks.
                  Stay secure. Stay confident. Stay ahead.

                </p>
                <ul className="banner-btn">
                  <li>
                    <a className="default-btn" href="/contact/">
                      Request Free Access
                    </a>
                  </li>
                  <li>
                    <a className="default-btn color-two" href="/contact/">
                      Get Started Now
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="new-main-banner-black-image">
                <img
                  src={blackBanner}
                  alt="Black Banner"
                  width={872}
                  height={700}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="new-main-banner-black-shape">
          <img src={lineBg} alt="Line Background" width={1920} height={988} />
        </div>
      </div>
      <div className="seku-features-area p-tb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6">
              <div className="single-seku-features-card">
                <h3>
                  <img src={feature1} alt="Security" width={35} height={40} />{" "}
                  Comprehensive Security
                </h3>
                <p>
                  Security isn’t just what we do—it’s our commitment to you. Using multi-layered defenses, advanced firewalls, intrusion detection, and proactive vulnerability management, we protect your business from every type of cyber threat.
                  From applications and networks to endpoints, we make sure your digital environment stays resilient, safe, and always one step ahead of attackers.
                  Secure your business. Protect your future.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="single-seku-features-card">
                <h3>
                  <img src={feature2} alt="Privacy" width={35} height={40} />{" "}
                  Privacy You Can Rely On
                </h3>
                <p>
                  Your trust is at the heart of everything we do. We implement strong privacy measures to protect your sensitive data, customer information, and business intelligence.
                  Our solutions are fully compliant with global standards like GDPR, HIPAA, and PCI DSS, so your organization stays secure, confident, and compliant.
                  Protect data. Earn trust. Stay compliant.

                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="single-seku-features-card">
                <h3>
                  <img
                    src={feature3}
                    alt="Industry Certified"
                    width={35}
                    height={40}
                  />{" "}
                  Industry-Certified Expertise
                </h3>
                <p>
                  Excellence isn’t just a claim—it’s proven. Our team consists of globally recognized experts certified in CEH, OSCP, CISSP, ISO 27001, and PCI DSS.
                  With deep industry knowledge and international best practices, we deliver unmatched protection for your business, keeping your digital environment secure, compliant, and future-ready.
                  Certified expertise. Trusted protection. Real results.

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="half-container">
          <h2>
            Our Security <span className="accent">PROFESSIONALS</span> with Top
          </h2>
          <p className="sub">Certifications</p>

          <div className="grid">
            <div className="card">
              <img
                src={certifiedLogos}
                alt="All security certifications"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="safer-world-area-without-color bg-color-add p-tb">
        <div className="container">
          <div className="row align-items-center">

            {/* Left Side Image */}
            <div className="col-lg-6 col-md-12">
              <div className="safer-world-image">
                <img
                  src={safer2}
                  alt="image"
                  width="606"
                  height="508"
                  loading="lazy"
                  decoding="async"
                  style={{ color: "transparent" }}
                />
              </div>
            </div>

            {/* Right Side Content */}
            <div className="col-lg-6 col-md-12">
              <div className="safer-world-content white-color-content">
                <h3>Building a Safer Digital Future for Your Business</h3>
                <p>
                  Cybersecurity isn’t just about protecting today—it’s about preparing for tomorrow. We help organizations innovate fearlessly, adopt modern technologies, and embrace digital transformation—all without security worries.
                  With our expertise, your business can grow, evolve, and thrive in a safe digital world.
                  Secure today. Innovate tomorrow.

                </p>

                <div className="row justify-content-center">
                  <div className="col-lg-12 col-md-6">
                    <div className="safer-world-inner-box">
                      <h4>Our Mission: Simplifying Cybersecurity for Everyone</h4>
                      <p>
                        We strive to create a secure digital ecosystem where businesses and individuals can operate freely, confidently, and without disruption.
                        Our goal is to make cybersecurity simple, effective, and reliable—protecting everyone from startups to enterprises so they can focus on growth, innovation, and success.
                        Secure. Simple. Reliable.

                      </p>
                    </div>
                  </div>

                </div>

                <div className="safer-world-btn">
                  <a className="default-btn" href="/about/">
                    Know More About Us
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="complete-website-security-area p-tb">
        <div className="container">

          {/* Section Title */}
          <div className="section-title">
            <h2>All-in-One Security for Your Digital Assets</h2>
            <p>
              We go beyond basic protection—delivering complete security solutions for your entire online presence. From websites and applications to data and networks, we safeguard every layer so your business stays safe, reliable, and worry-free.
              Protect more. Worry less. Stay secure.

            </p>
          </div>

          {/* Cards */}
          <div className="row justify-content-center">

            <div className="col-lg-3 col-sm-6">
              <div className="complete-website-security-card mb-25">
                <div className="icon">
                  <i class="bx bx-bug"></i>
                </div>
                <h3>
                  <a href="/services/details/">Advanced Threat Protection</a>
                </h3>
                <p>
                  Cyber threats evolve every day. We stay ahead with real-time monitoring, threat intelligence, and proactive defense, so your business stays one step ahead of attackers.
                  Stay protected. Stay confident.

                </p>
                <div className="security-shape">
                  <img
                    src={shape2}
                    alt="image"
                    width="124"
                    height="132"
                    loading="lazy"
                    decoding="async"
                    style={{ color: "transparent" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="complete-website-security-card mb-25">
                <div className="icon">
                  <i class="bx bx-file"></i>
                </div>
                <h3>
                  <a href="/services/details/">Secure Your Data, Secure Your Future</a>
                </h3>
                <p>
                  Your data is your most valuable asset. We ensure it’s encrypted, monitored, and safeguarded against breaches, leaks, and unauthorized access.
                  Protect your information. Build trust.

                </p>
                <div className="security-shape">
                  <img
                    src={shape2}
                    alt="image"
                    width="124"
                    height="132"
                    loading="lazy"
                    decoding="async"
                    style={{ color: "transparent" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="complete-website-security-card mb-25">
                <div className="icon">
                  <i class="bx bx-user-circle"></i>
                </div>
                <h3>
                  <a href="/services/details/">Security Made Simple</a>
                </h3>
                <p>
                  Cybersecurity can be complex—but we make it simple, effective, and reliable. From small startups to large enterprises, our solutions are tailored to fit your needs.
                  Simple security. Maximum protection.

                </p>
                <div className="security-shape">
                  <img
                    src={shape2}
                    alt="image"
                    width="124"
                    height="132"
                    loading="lazy"
                    decoding="async"
                    style={{ color: "transparent" }}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="complete-website-security-card mb-25">
                <div className="icon">
                  <i class="bx bx-globe"></i>
                </div>
                <h3>
                  <a href="/services/details/">Protect Every Layer</a>
                </h3>
                <p>
                  From networks and endpoints to applications and cloud environments, we provide 360° security coverage to keep your business safe from all angles.
                  Complete protection. Total peace of mind.

                </p>
                <div className="security-shape">
                  <img
                    src={shape2}
                    alt="image"
                    width="124"
                    height="132"
                    loading="lazy"
                    decoding="async"
                    style={{ color: "transparent" }}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="cyber-defenses-area bg-color-add p-tb">
        <div className="container">
          <div className="section-title">
            <h2>Expert Support to Strengthen Your Cyber Defenses</h2>
           <p className="text-white">Cyber threats evolve every day—and so should your defenses. At [Your Company Name], we go beyond tools to deliver the trusted expertise your business needs to stay secure.
</p>
          </div>
          <div className="cyber-defenses-list-tabs">
            <div className="tab-container">
              <div className="tab-buttons react-tabs__tab-list">
                <button className="react-tabs__tab--selected react-tabs__tab" data-tab="1">Vulnerability Assessment</button>
                <button className="react-tabs__tab" data-tab="2">Penetration Testing</button>
                <button className="react-tabs__tab" data-tab="3">Configuration Review</button>
                <button className="react-tabs__tab" data-tab="4">Red Team Assessment</button>
                <button className="react-tabs__tab" data-tab="5">Compliance Audits</button>
              </div>

              <div className="tab-content react-tabs__tab--selected " data-content="1">
                <div className="tab-content-inner">
                  <h3>Stay one step ahead of attackers. Our Vulnerability Assessments identify, analyze, and prioritize weaknesses across your IT infrastructure, applications, and networks—before they can be exploited.
                 </h3>
                 <ul>
                  <li>Identify</li>
                  <li>Analyze</li>
                  <li>Prioritize</li>
                  <li>Remediate</li>
                 </ul>
                  <p>We assess networks, applications, databases, cloud, and endpoints using a mix of automated tools, manual reviews, and threat intelligence. This process helps prevent breaches, ensures regulatory compliance (PCI DSS, ISO 27001, HIPAA), and strengthens overall resilience.
                  </p>
                </div>
              </div>
              <div className="tab-content" data-content="2">
                <div className="tab-content-inner">
                  <h3>Test your defenses the way hackers would. Our Penetration Testing (Pen Test) simulates real-world cyberattacks to expose exploitable weaknesses and demonstrate the true impact of a breach.</h3>
                  <ul>
                    <li>Reconnaissance</li>
                    <li>Exploitation</li>
                    <li>Privilege Escalation</li>
                    <li>Reporting & Guidance</li>
                  </ul>
                  <p>We test web apps, APIs, mobile apps, networks, and even human factors (social engineering). Unlike vulnerability scans, pen tests actively exploit flaws to reveal how attackers could chain them together.</p>
                </div>
              </div>
              <div className="tab-content" data-content="3">
                <div className="tab-content-inner">
                  <h3>Don’t let small mistakes open big doors. A Configuration Review validates that your systems, apps, and devices are properly set up to minimize risk.</h3>
                  <ul>
                    <li>Baseline Review</li>
                    <li>Gap Identification</li>
                    <li>Hardening Recommendations</li>
                    <li>Validation & Compliance</li>
                  </ul>
                  <p>We cover firewalls, servers, databases, endpoints, and cloud platforms. This process reduces your attack surface, prevents unauthorized access, and helps you stay compliant.</p>
                </div>
              </div>
              <div className="tab-content" data-content="4">
                <div className="tab-content-inner">
                  <h3>Go beyond testing vulnerabilities—test your entire security readiness. Our Red Team Assessments simulate sophisticated, multi-layered cyberattacks to evaluate how your people, processes, and technology hold up under pressure.</h3>
                  <ul>
                    <li>Plan & Gather Intel</li>
                    <li>Simulate Attacks</li>
                    <li>Evade & Persist</li>
                    <li>Evaluate Response</li>
                  </ul>
                  <p>This isn’t just about finding weaknesses—it’s about assessing your incident response, detection gaps, and cyber resilience in real-world conditions.</p>
                </div>
              </div>
              <div className="tab-content" data-content="5">
                <div className="tab-content-inner">
                  <h3>Show the world your commitment to security. Our Compliance Audits verify your alignment with leading industry regulations and frameworks.</h3>
                  <ul>
                    <li>Requirement Mapping</li>
                    <li>Documentation Review</li>
                    <li>Control Testing</li>
                    <li>Audit Reporting</li>
                  </ul>
                  <p>Beyond achieving certifications, audits build trust with customers, partners, and regulators—proving that your security is not just compliant, but reliable.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <section className="cybersecurity-area p-tb">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="cybersecurity-content">
                <h2>24/7 Cybersecurity Support, Whenever You Need It</h2>
                <p>
                Cyber threats don’t wait—and neither do we. Our expert support team is available around the clock to answer questions, resolve incidents, and provide immediate assistance. No matter the time or time zone, we’re always here to keep your business safe.
                </p>

                <div className="row">
                  <div className="col-lg-6 col-sm-6">
                    <ul className="cybersecurity-item">
                      <li>
                        <i className="bx bx-check"></i> Managed Web Application
                      </li>
                      <li>
                        <i className="bx bx-check"></i> SIEM Threat Detection
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Content Delivery Network
                      </li>
                      <li>
                        <i className="bx bx-check"></i> 24/7 Hours Services
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Security Management
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6">
                    <ul>
                      <li>
                        <i className="bx bx-check"></i> Instant Malware Removal
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Free Delivery Services
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Website Hack Repair
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Website Security Services
                      </li>
                      <li>
                        <i className="bx bx-check"></i> Provide Security Services
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 pr-0">
              <div className="cybersecurity-img">
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="testimonials-wrap-area bg-color-add p-tb">
        <div className="container">
          <div className="section-title white-title">
            <h2>What Our Clients Say About Us</h2>
            <p>Our clients trust us because we deliver real results, stronger security, and complete peace of mind. Here’s what they have to say:</p>
          </div>
          <div className="carousel" aria-label="Testimonials carousel">
            <div className="viewport">
              <div className="track">
                <article className="card" aria-hidden="false">
                  <p> “The team at Pranasrishti Solutions has transformed the way we approach cybersecurity. Their proactive support and expertise give us confidence that our business is always protected.”</p>
                  <h3>Patric Watler</h3>
                  <span className="role">Manager</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p>“Reliable, responsive, and professional — they don’t just secure our systems, they make us feel safe to grow.”</p>
                  <h3>Jane Anderson</h3>
                  <span className="role">Developer</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p> “With their 24/7 monitoring and quick response, we no longer worry about threats. We know we’re in safe hands.”</p>
                  <h3>Victor James</h3>
                  <span className="role">Designer</span>
                  <div className="stars">★★★★★</div>
                </article>
                <article className="card" aria-hidden="false">
                  <p> “The team at Pranasrishti Solutions has transformed the way we approach cybersecurity. Their proactive support and expertise give us confidence that our business is always protected.”</p>
                  <h3>Patric Watler</h3>
                  <span className="role">Manager</span>
                  <div className="stars">★★★★★</div>
                </article>
              </div>
            </div>
            <div className="dots" aria-hidden="false"></div>
          </div>
        </div>
      </div>
    </>
  );
}
export default BannerSection;